import {
  BaseDialog,
  FlexBox,
  SanitizedTrimmedHtml,
} from '@airship-platform/jam-web/components';
interface SOWModalProps {
  title: string;
  summary: string;
  open: boolean;
  onClose: () => void;
}

const SOWModal = ({ title, summary, open, onClose }: SOWModalProps) => {
  return (
    <BaseDialog title={title} open={open} onClose={onClose}>
      <FlexBox flexDirection={'column'} gap={2}>
        <SanitizedTrimmedHtml html={summary} />
      </FlexBox>
    </BaseDialog>
  );
};

export default SOWModal;
